import { RestLoginSessionBean, AttributeCacheBean } from "./ds.js";

export class RestItemMergeResponseBean {
  constructor() {
    this.isSuccess = false;
    this.errors = new Array();
    this.warnings = new Array();
    this.infos = new Array();
    this.isSessionExpired = false;
    this.itemResponse = null;
    this.lockResponse = null;
  }
}

export class ApplicationData {
  constructor() {
    this.loginSession = new RestLoginSessionBean();
    this.attributeCache = new AttributeCacheBean();

    this.companyCode = "";
    this.serverVersion = "";
    this.guiVersion = "";
    this.applicationName = "";
    this.applicationMainImagePath = "";
    this.applicationLogoImagePath = "";
  }
}

// export class ApplicationData {
//   constructor() {
//     this.loginSession = new RestLoginSessionBean();
//     this.attributeCache = new AttributeCacheBean();

//     this.companyCode = "";
//     this.serverVersion = "";
//     this.guiVersion = "";
//     this.applicationName = "";
//     this.applicationMainImagePath = "";
//     this.applicationLogoImagePath = "";
//   }
// }

export class NodeData {
  constructor(nodeKey, nodeCaption, nodeObject) {
    this.nodeKey = nodeKey;
    this.nodeCaption = nodeCaption;
    this.nodeObject = nodeObject;
  }
}

// Module Related
export class MetalTypeSearchCriteria {
  constructor() {
    this.companyCode = "";
    this.code = "";
    this.name = "";
    this.sortBy = "";
    this.modificationTrackNumber = "";
    this.codeList = new Array();
  }
}

export class MetalTypeResponseBean {
  constructor() {
    this.metalType = null;
    this.isSuccess = false;
    this.errors = new Array();
    this.warnings = new Array();
    this.infos = new Array();
    this.isSessionExpired = false;
  }
}

export class MetalTypePageListResponseBean {
  constructor() {
    this.metalTypePageList = null;
    this.isSuccess = false;
    this.errors = new Array();
    this.warnings = new Array();
    this.infos = new Array();
    this.isSessionExpired = false;
  }
}

export class MetalTypePageListBean {
  constructor() {
    this.metalTypes = new Array();
    this.totalCount = 0;
    this.currentPage = 0;
    this.pageSize = 0;
  }
}

export class MetalTypeBean {
  constructor() {
    this.uomCode = "";
    this.price = 0;
    this.internalTypeCode = "";
    this.companyCode = "";
    this.isDefault = false;
    this.displayOrder = 0;
    this.code = "";
    this.description = "";
    this.isActive = false;
    this.isFetched = false;
    this.isDeleted = false;
    this.createdBy = "";
    this.updatedBy = "";
    this.deletedBy = "";
    this.createdDate = null;
    this.updatedDate = null;
    this.deletedDate = null;
    this.isApplied = false;
    this.notesCommunication = "";
    this.modificationTrackNumber = 0;
  }
}

export class ResponseBean {
  constructor() {
    this.isSuccess = false;
    this.errors = new Array();
    this.warnings = new Array();
    this.infos = new Array();
    this.isSessionExpired = false;
  }
}

export class MessageBean {
  constructor() {
    this.messageID = "";
    this.messageDescription = "";
    this.messageTarget = "";
  }
}

export class PageListBean {
  constructor() {
    this.totalCount = 0;
    this.currentPage = 0;
    this.pageSize = 0;
  }
}

export class RestWareHouseSearchCriteria {
  constructor() {
    this.companyCode = "";
    this.code = "";
    this.name = "";
    this.sortBy = "";
    this.modificationTrackNumber = "";
    this.codeList = new Array();
  }
}
export class RestReportBean {
  constructor() {
    this.reportName = "";
    this.reportFileID = "";
    this.reportType = 0;
    this.reportFilePath = "";
  }
}

export class ItemSKUBatchInventorySearchCriteriaBean {
  constructor() {
    this.companyCode = "";
    this.itemCode = "";
    this.dimensionCode = "";
    this.sizeCode = "";
    this.skuNumber = 0;
    this.locationCode = ""; // Primary Key

    this.purchaseOrderReceiptNumber = "";
    this.purchaseOrderNumber = "";

    this.uomCode = "";
    this.currencyCode = "";

    this.colorCode = "";

    this.binLocation = "";
    this.batchNumber = "";
    this.inventoryFetchType = 0;

    this.qualityCodeStartsWith = "";
    this.sizeCodeStartsWith = "";
  }
}

export class RestPriceLevelConfigBean {
  constructor() {
    this.fromQuantity = 0;
    this.toQuantity = 0;
    this.discountPercentage = 0;
  }
}

export class SimpleItemBean {
  constructor() {
    this.code = "";
    this.description = "";
    this.detailDescription = "";
  }
}

export class BaseBean {
  constructor() {
    this.code = "";
    this.description = "";
    this.isActive = false;
    this.isFetched = false;
    this.isDeleted = false;
  }
}

export class MasterAttributeBean {
  constructor() {
    this.code = "";
    this.description = "";
    this.companyCode = "";
    this.isActive = false;
    this.isFetched = false;
    this.isDeleted = false;
    this.isApplied = false;
    this.isDefault = false;
    this.displayOrder = 0;
  }
}

export class BaseImageBean {
  constructor() {
    this.code = "";
    this.imgData = null;
    this.isActive = false;
    this.isFetched = false;
    this.isDeleted = false;
  }
}

export class CustomRollDataConversionCriteria {
  constructor() {
    this.IsReserveCustomerUpdateFlag = false;
    this.IsContainerUpdateFlag = false;
    this.IsShadeUpdateFlag = false;
    this.IsBillofLadingUpdateFlag = false;
    this.IsVendorBatchNumberUpdateFlag = false;
    this.IsEtaDateUpdateFlag = false;
  }
}

export class ColmDef {
  constructor() {
    this.Header = "";
    this.accessor = "";
    this.isActive = false;
    this.isFetched = false;
    this.isDeleted = false;
  }
}

export class PurchaseOrderReceiptRollLineBeanFilter {
  constructor() {
    this.vendorLotNumber = "";
    this.rollSkuNumber = "";
    this.receivedQuantity = 0;
    this.rollNumber = "" ;
  }
}


export class LogisticOrderReceiptRollLineBeanFilter {
  constructor() {
    this.vendorLotNumber = "";
    this.rollSkuNumber = "";
    this.receivedQuantity = 0;
    this.rollNumber = "" ;
  }
}

